import { useEffect, useRef } from 'react'

/**
 * Runs `onIncrement` only when `token` rises (toolbar expand/collapse). Skips
 * remounts and data refreshes such as a tag-filter refetch of the same report.
 */
export const useOnTokenIncrement = (token: number, onIncrement: () => void) => {
  const previousToken = useRef(token)
  const onIncrementRef = useRef(onIncrement)
  onIncrementRef.current = onIncrement

  useEffect(() => {
    if (token === previousToken.current) return
    previousToken.current = token
    if (!token) return
    onIncrementRef.current()
  }, [token])
}
